// authService.js or any non-component file
const handleTokenExpiration = () => {
    try {
      localStorage.removeItem('Aprofile')
      window.location.reload(true)
    } catch (error) {
      console.error('Error handling token expiration:', error)
      // Optionally, you can log the error or perform other actions
    }
  }
  
  export default handleTokenExpiration
  